module.exports = __webpack_public_path__ + "img/p3.27d26ab8.png";